<h3>🌱 {{ title }}</h3>
@if (data) {
  <div class="grid-container">
    <mds-grid
      [domLayout]="data.printLayout"
      [overrides]="overrides"
      [sizeColumnsToFit]="false"
      [themeClass]="'ag-theme-material'"
      minHeight="80"
    ></mds-grid>
  </div>
}
@if (data.subtext) {
  <sub>{{ data.subtext }}</sub>
}
